import { css } from 'react-emotion'

const styles = {
  logoHeader: css({
    marginTop: '20px !important'
  }),
  layout: css({
    height: '100% !important',
    backgroundColor: '#f6f6f6'
  }),
  grid: css({
    maxWidth: '450px'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Pages/Layouts/AuthStyles.js